<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<div>
			<app-color-searchable
				[label]="'vehicles|record|color-section|exterior-color'"
				[filters]="{
					types: [exteriorColorType],
				}"
				[searchableId]="
					detailsForm.get('exteriorColorId')
				"></app-color-searchable>
			<app-color-searchable
				[label]="'vehicles|record|color-section|interior-color'"
				[filters]="{
					types: [interiorColorType],
				}"
				[searchableId]="
					detailsForm.get('interiorColorId')
				"></app-color-searchable>
		</div>
	</form>
</app-section-wrapper-container>
